var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticStyle:{"text-align":"center","color":"red","font-weight":"bold"},attrs:{"colspan":"3"}},[_vm._v("\n    Campaign Deleted\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }